import { render, staticRenderFns } from "./exhibition-activity-edit.vue?vue&type=template&id=038b8bb5&scoped=true&"
import script from "./exhibition-activity-edit.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-edit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-activity-edit.vue?vue&type=style&index=1&id=038b8bb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b8bb5",
  null
  
)

export default component.exports